var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8_expand 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.35,
    d: "M8.91775 16.0823C8.30733 15.4718 7.31879 15.4718 6.70837 16.0823L4.62504 18.1656L3.32817 16.8687C2.86879 16.4104 2.08337 16.7354 2.08337 17.3854V21.875C2.08337 22.45 2.55004 22.9166 3.12504 22.9166H7.61462C8.26462 22.9166 8.58962 22.1312 8.13025 21.6718L6.83337 20.376L8.91671 18.2927C9.52712 17.6823 9.52712 16.6927 8.91775 16.0823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3854 22.9167H21.875C22.45 22.9167 22.9167 22.45 22.9167 21.875V17.3854C22.9167 16.7354 22.1312 16.4104 21.6719 16.8698L16.8698 21.6719C16.4104 22.1312 16.7354 22.9167 17.3854 22.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.7917 21.3542C19.3917 21.3542 18.9917 21.2021 18.6865 20.8969L16.0823 18.2927C15.4719 17.6834 15.4719 16.6927 16.0823 16.0834C16.6927 15.4729 17.6813 15.4729 18.2917 16.0834L20.8959 18.6875C21.5063 19.2969 21.5063 20.2875 20.8959 20.8969C20.5917 21.2021 20.1917 21.3542 19.7917 21.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.61462 2.08331H3.12504C2.55004 2.08331 2.08337 2.54998 2.08337 3.12498V7.61456C2.08337 8.26456 2.86879 8.58956 3.32817 8.13019L8.13025 3.3281C8.58962 2.86873 8.26462 2.08331 7.61462 2.08331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.81245 9.37501C7.41245 9.37501 7.01245 9.22292 6.70724 8.91772L4.10308 6.31355C3.49266 5.70417 3.49266 4.71355 4.10308 4.10417C4.71349 3.49376 5.70203 3.49376 6.31245 4.10417L8.91662 6.70834C9.52704 7.31772 9.52704 8.30834 8.91662 8.91772C8.61245 9.22292 8.21245 9.37501 7.81245 9.37501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.35,
    d: "M21.875 2.08331H17.3854C16.7354 2.08331 16.4104 2.86873 16.8698 3.3281L18.1666 4.62498L16.0833 6.70831C15.4729 7.31769 15.4729 8.30831 16.0833 8.91769C16.3875 9.2229 16.7875 9.37498 17.1875 9.37498C17.5875 9.37498 17.9875 9.2229 18.2927 8.91769L20.376 6.83435L21.6729 8.13019C22.1312 8.58956 22.9166 8.26456 22.9166 7.61456V3.12498C22.9166 2.54998 22.45 2.08331 21.875 2.08331Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandOpen);
export default __webpack_public_path__ + "static/media/expand-open.2d054ac1fb110373f5d456a2a359c1f0.svg";
export { ForwardRef as ReactComponent };